import {AppStoreText} from '@/routes/AppStoreRedirect';
import {track} from '@amplitude/analytics-browser';
import {AccountEvents} from './eventTypes/AccountEvents';
import {AmenitiesEvents} from './eventTypes/AmenitiesEvents';
import {ApplicantEvents} from './eventTypes/ApplicantEvents';
import {ApplicationsEvents} from './eventTypes/ApplicationsEvents';
import {AppointmentsEvents} from './eventTypes/AppointmentsEvents';
import {EventsEvents} from './eventTypes/CommunityEventEvents';
import {CommunityEventPartyEvents} from './eventTypes/CommunityEventPartyEvents';
import {CommunityProductsEvents} from './eventTypes/CommunityProductsEvents';
import {CommunityUpdateEvents} from './eventTypes/CommunityUpdateEvents';
import {ContactBookingsEvents} from './eventTypes/ContactBookingsEvents';
import {ContactNotesEvents} from './eventTypes/ContactNotes';
import {ContactPackageEvents} from './eventTypes/ContactPackageEvents';
import {ContactsEvents} from './eventTypes/ContactsEvents';
import {ConversationEvents} from './eventTypes/ConversationEvents';
import {ConversationNotesEvents} from './eventTypes/ConversationNotesEvents';
import {DocumentPaywallEvents} from './eventTypes/DocumentPaywallEvents';
import {DocumentsEvents} from './eventTypes/DocumentsEvents';
import {FeaturesEvents} from './eventTypes/FeaturesEvents';
import {FormEvents} from './eventTypes/FormsEvents';
import {GroupsEvents} from './eventTypes/GroupsEvents';
import {HomePageEvents} from './eventTypes/HomePageEvents';
import {HomesEvents} from './eventTypes/HomesEvents';
import {KeysEvents} from './eventTypes/KeysEvents';
import {MarketplaceEvents} from './eventTypes/MarketplaceEvents';
import {NavigationEvents} from './eventTypes/NavigationEvents';
import {NewPackagesEvents} from './eventTypes/NewPackagesEvents';
import {NotificationEvents} from './eventTypes/NotificationEvents';
import {PackageEvents} from './eventTypes/PackagesEvents';
import {PackageStatusEvent} from './eventTypes/PackageStatusEvents';
import {PulseEvents} from './eventTypes/PulseEvents';
import {PaymentsEvents} from './eventTypes/PaymentsEvents';
import {ProfileEvents} from './eventTypes/ProfileEvents';
import {PropertyEvents} from './eventTypes/PropertyEvents';
import {ReferencingEvents} from './eventTypes/ReferencingEvents';
import {RemoveResidentEvents} from './eventTypes/RemoveResidentEvents';
import {RulesEvents} from './eventTypes/RulesEvents';
import {SurveysEvents} from './eventTypes/SurveysEvents';
import {SwitchFlowEvents} from './eventTypes/SwitchFlowEvents';
import {TasksEvents} from './eventTypes/TasksEvents';
import {ReportingEvents} from './eventTypes/ReportingEvents';
import {TenancyEvents} from './eventTypes/TenancyEvents';
import {TenantEvents} from './eventTypes/TenantEvents';
import {VisitorsEvents} from './eventTypes/VisitorsEvents';
import {ContractorsEvents} from './eventTypes/ContractorsEvents';
import {ContractorSuggestionEvents} from './eventTypes/ContractorSuggestionEvents';
// Generic event types
export type BaseEvent<EventName, EventData = undefined> = {
  name: EventName;
  data: EventData;
};
export type SimpleEvent<EventName> = {
  name: EventName;
};

type AppRedirectEvent = BaseEvent<
  'App Redirect',
  {
    target: string;
    protocol: string;
    pathname: string;
    email: string;
  }
>;

type AppStoreRedirectEvent = BaseEvent<
  'App Store Redirect',
  {
    store: AppStoreText;
  }
>;

export type AmplitudeEvent =
  | AccountEvents
  | PropertyEvents
  | TenancyEvents
  | ConversationEvents
  | SwitchFlowEvents
  | PaymentsEvents
  | NavigationEvents
  | TenantEvents
  | ReferencingEvents
  | DocumentPaywallEvents
  | HomePageEvents
  | CommunityUpdateEvents
  | AmenitiesEvents
  | AppRedirectEvent
  | AppStoreRedirectEvent
  | KeysEvents
  | ApplicationsEvents
  | PackageEvents
  | DocumentsEvents
  | MarketplaceEvents
  | ConversationNotesEvents
  | RemoveResidentEvents
  | PackageStatusEvent
  | FormEvents
  | CommunityEventPartyEvents
  | ContactNotesEvents
  | ContactPackageEvents
  | ContactBookingsEvents
  | NewPackagesEvents
  | HomesEvents
  | VisitorsEvents
  | EventsEvents
  | AppointmentsEvents
  | ContactsEvents
  | GroupsEvents
  | SurveysEvents
  | ProfileEvents
  | FeaturesEvents
  | CommunityProductsEvents
  | ApplicantEvents
  | NotificationEvents
  | PulseEvents
  | RulesEvents
  | TasksEvents
  | ContractorsEvents
  | ContractorSuggestionEvents
  | ReportingEvents;

export const recordEvent = (event: AmplitudeEvent) => {
  const {name, data} = event as BaseEvent<string, unknown>;
  if (data) {
    track(name, data);
  } else {
    track(name);
  }
};

export const useLogEvent = () => recordEvent;
